import React, { type Dispatch, type FC } from 'react';
import { FilterPill } from 'venn-ui-kit';
import type { PortfolioAccountStatusEnum, TaxStatusEnum } from 'venn-api';

export type FilterState = {
  household: string[];
  client: string[];
  program: string[];
  status: PortfolioAccountStatusEnum[];
  taxStatus: TaxStatusEnum[];
};
export type FilterKey = keyof FilterState;

export type FilterAction =
  | { type: 'set'; key: FilterKey; values: string | string[] }
  | { type: 'remove'; key: FilterKey; value: string }
  | { type: 'clearAll' };

export type FilterPillData = {
  name: string;
  value: string;
};
export const FilterPillGroup: FC<{
  pills: FilterPillData[];
  dispatch: Dispatch<FilterAction>;
  prefix: string;
}> = ({ pills, dispatch, prefix }) => (
  <>
    {pills.map((p) => (
      <FilterPill
        key={`${prefix}-${p.value}`}
        name={p.name}
        onClose={() => dispatch({ type: 'remove', key: prefix as FilterKey, value: p.value })}
        refreshedStyling
      />
    ))}
  </>
);
